import markSrc from "@/assets/avm-mark.png";
import lockupSrc from "@/assets/avm-logo.png";

// The official AVM crown logo, used exactly as supplied.
export const Logo = ({ size = 40, className = "", variant = "mark" }) => {
    const src = variant === "full" ? lockupSrc : markSrc;
    return (
        <img
            src={src}
            alt="ayevibemuzik"
            style={{ height: size, width: "auto" }}
            className={className}
            data-testid={variant === "full" ? "brand-logo-lockup" : "brand-logo-mark"}
        />
    );
};

export default Logo;
